import { render, staticRenderFns } from "./CreateOrganizer.vue?vue&type=template&id=401391a4&scoped=true"
import script from "./CreateOrganizer.vue?vue&type=script&lang=js"
export * from "./CreateOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401391a4",
  null
  
)

export default component.exports